module.exports = __webpack_public_path__ + "static/media/placeholder.dea6c4d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/SpeakersSection/placeholder.svg
// module id = 1118
// module chunks = 1